import script from "./RealTime.vue?vue&type=script&setup=true&lang=js"
export * from "./RealTime.vue?vue&type=script&setup=true&lang=js"

import "./RealTime.vue?vue&type=style&index=0&id=684041fd&lang=scss"

const __exports__ = script;

export default __exports__